import "dayjs/locale/it";
import dayjs from "dayjs";

export function configureDayJs(): void {
  dayjs.locale("it");
}
